/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import React from "react";
import ReactDOM from "react-dom";
import SearchResultsFeedback from "../components/SearchResultsFeedback";
import SearchResultList from "../components/SearchResultList";
import SearchResultsPhotos from "../components/SearchResultsPhotos";

// Support component names relative to this directory:
// const componentRequireContext = require.context("components", true);
// import ReactRailsUJS from "react_ujs";
// console.log("ReactRailsUJS", ReactRailsUJS);

// ReactRailsUJS.useContext(componentRequireContext);

// Importing components from the top-level components directory
// import ErrorPage from "../components/ErrorPage.jsx";
// import ErrorSearch from "../components/ErrorSearch.jsx";
// import HotelRating from "../components/HotelRating.jsx";
// import HotelScoreRange from "../components/HotelScoreRange.jsx";
// import PageResultList from "../components/PageResultList.jsx";
// import PageResultPhotos from "../components/PageResultPhotos.jsx";
// import SearchResultList from "../components/SearchResultList.jsx";
// import SearchResultsFeedback from "../components/SearchResultsFeedback.jsx";
// import SearchResultsPhotos from "../components/SearchResultsPhotos.jsx";
// import StrongDemand from "../components/StrongDemand.jsx";

// // Importing components from the nested search directory
// import HotelGeo from "../components/search/HotelGeo.jsx";
// import HotelShortReview from "../components/search/HotelShortReview.jsx";
// import Pagination from "../components/search/Pagination.jsx";
// import PaginationLink from "../components/search/PaginationLink.jsx";
// import ResultListCore from "../components/search/ResultListCore.jsx";
// import ResultListHeading from "../components/search/ResultListHeading.jsx";
// import ResultListHotelPicture from "../components/search/ResultListHotelPicture.jsx";
// import ResultListOffer from "../components/search/ResultListOffer.jsx";
// import ResultListResult from "../components/search/ResultListResult.jsx";
// import ResultPhotosResult from "../components/search/ResultPhotosResult.jsx";

// Map them for easy reference
// const components = {
//   ErrorPage,
//   ErrorSearch,
//   HotelRating,
//   HotelScoreRange,
//   PageResultList,
//   PageResultPhotos,
//   SearchResultList,
//   SearchResultsFeedback,
//   SearchResultsPhotos,
//   StrongDemand,

//   // Components from search directory
//   HotelGeo,
//   HotelShortReview,
//   Pagination,
//   PaginationLink,
//   ResultListCore,
//   ResultListHeading,
//   ResultListHotelPicture,
//   ResultListOffer,
//   ResultListResult,
//   ResultPhotosResult,
// };

const $ = jQuery;
let statusHandler;
let stopPullingAfter;
let form;
let feedback;
let lastSuccessResultsCount;
let statusErrorsCount;
let searchTemplate;
let jqxhrMainResults;
let pullTimeout;

const setFeedback = (message) => {
  const state = {
    message,
    loader: false,
  };

  if (message === "still_progress" || message === "starting") {
    state.loader = searchTemplate !== "map";
  }

  feedback.setState(state);
};

const startPulling = (url, initialOptions = {}) => {
  setFeedback("starting");
  lastSuccessResultsCount = 0;
  pullTimeout = false;

  // N'attend pas le premier timeout pour faire une cherche
  // Envoie une copie des options car on va modifier ces options par la suite
  pull(url, $.extend(true, {}, initialOptions));
  const { successCallbackOnce, beforeSendCallbackOnce, ...options } =
    initialOptions;

  // stop le pull après x secondes
  stopPullingAfter = new Date().getTime() + 60 * 1000;

  statusHandler = setInterval(() => {
    if (window.statusXHRPending === 0 || window.statusXHRPending == null) {
      pull(url, options);
    }

    if (new Date().getTime() > stopPullingAfter) {
      stopPulling();
      pullTimeout = true;

      if (lastSuccessResultsCount === 0) {
        setFeedback("error");
      } else {
        setFeedback(false);
      }
    }
  }, 2000);
};

const stopPulling = () => {
  if (typeof statusHandler !== "undefined") {
    clearInterval(statusHandler);
    statusHandler = undefined;
  }
};

const updateFeedbackWithJson = (json) => {
  if (json.completed === false) {
    if (pullTimeout) {
      if (lastSuccessResultsCount > 0) {
        setFeedback(false);
      } else {
        setFeedback("error");
      }
    } else if (json.stats.all_results_count > 0) {
      setFeedback("still_progress");
    } else {
      setFeedback("starting");
    }
  } else if (json.stats.all_results_count === 0) {
    setFeedback("noresult");
  } else {
    setFeedback(false);
  }
};

const scrollToTop = () => {
  const body = $("html, body");
  const scrollTo = $("#search_container").offset().top - 10;

  body.animate({ scrollTop: scrollTo }, 250, "swing");
};

const updateTabsUrls = (urls) => {
  Object.entries(urls).forEach(([name, url]) => {
    const link = document.getElementById(`tab-${name}`);
    if (link) {
      link.href = url;
    }
  });
};

const pushStateEnabled = () => {
  // from https://github.com/defunkt/jquery-pjax/blob/master/jquery.pjax.js
  return window.history && window.history.pushState;
};

const pushUrl = (url) => {
  if (!pushStateEnabled()) {
    return;
  }

  const state = {
    url,
  };

  window.history.pushState(state, null, url);

  HAP.helpers.trackPageView(url);
};

const changeUrl = (browserUrl, pullUrl) => {
  const options = {
    beforeSendCallbackOnce() {
      scrollToTop();
      $("html, body").css("cursor", "progress");
    },

    successCallbackOnce(response) {
      $("html, body").css("cursor", "default");
      updateTabsUrls(response.tabs_urls);
      pushUrl(browserUrl);
    },
  };

  restartPulling(pullUrl, options);
};

function updateWithJson(json) {
  if (json.stats && json.stats.all_results_count !== undefined) {
    lastSuccessResultsCount = json.stats.all_results_count;
  }

  updateFeedbackWithJson(json);

  if (json.results_list) {
    const element = React.createElement(SearchResultList, {
      results: json.results_list,
      searchAttributes: json.searchAttributes,
      pagination: json.pagination,
      stats: json.stats,
      completed: json.completed,
      hasCriterias: json.hasCriterias,
      changeUrl,
    });

    ReactDOM.render(element, document.getElementById("search-content"));
  } else if (json.map_criterias) {
    HAP.map_data = {
      prices: json.prices,
      displayed_hotels: json.displayed_hotels,
    };

    const { maps } = HAP;
    const map = maps.getMap("map");

    if (map && json.cache_key !== map.cache_key) {
      maps.removeHotelsLayers(map);
      maps.createHotelsLayers(map, {
        criterias: json.map_criterias,
      });
      map.cache_key = json.cache_key;
    }
  } else if (json.results_photos) {
    const element = React.createElement(SearchResultsPhotos, {
      results: json.results_photos,
      searchAttributes: json.searchAttributes,
      pagination: json.pagination,
      stats: json.stats,
      completed: json.completed,
      hasCriterias: json.hasCriterias,
      changeUrl,
    });

    ReactDOM.render(
      element,
      document.getElementById("search-content"),
      HAP.sliders.searchPhotos
    );
  }

  if (json.top_form_summary_title_html) {
    $("#top-form-summary-title").html(json.top_form_summary_title_html);
  }

  if (json.top_form_results_rows_html) {
    $("#top-form-results-rows").html(json.top_form_results_rows_html);
  }
}

const rebuildContent = () => {
  let component;
  if (searchTemplate === "list") {
    component = SearchResultList;
  } else if (searchTemplate === "photos") {
    component = SearchResultsPhotos;
  }

  if (component) {
    const element = React.createElement(component);
    ReactDOM.render(element, document.getElementById("search-content"));
  }
};

function pull(url, options = {}) {
  jqxhrMainResults = jQuery
    .ajax({
      method: "GET",
      url,
      cache: true,
      dataType: "json",
      data: options.pullData ? options.pullData() : undefined,
      beforeSend() {
        if (typeof jqxhrMainResults !== "undefined") {
          jqxhrMainResults.abort();
        }

        window.statusXHRPending = 1;

        if (options.beforeSendCallbackOnce) {
          options.beforeSendCallbackOnce();
        }
      },

      success(response) {
        if (response.completed) {
          stopPulling();
        }

        updateWithJson(response);

        if (options.successCallbackOnce) {
          options.successCallbackOnce(response);
        }
      },
    })

    .always(() => {
      window.statusXHRPending = 0;
      jqxhrMainResults = undefined;
    })

    .fail((xhr, status) => {
      if (status !== "abort") {
        if (statusErrorsCount === undefined) {
          statusErrorsCount = 1;
        } else {
          statusErrorsCount += 1;
        }
        if (statusErrorsCount >= 5) {
          stopPulling();

          if (lastSuccessResultsCount === 0) {
            setFeedback("error");
          } else {
            setFeedback("starting");
          }
        }
      }
    });
}

function getFiltersSortPullOptions(options) {
  return {
    pullData() {
      return form.serialize();
    },

    beforeSendCallbackOnce() {
      if (!options.scrollToTop === undefined || options.scrollToTop) {
        scrollToTop();
      }

      $("html, body").css("cursor", "progress");

      if (options.beforeSendCallbackOnce) {
        options.beforeSendCallbackOnce();
      }
    },

    successCallbackOnce(response) {
      $("html, body").css("cursor", "default");
      updateTabsUrls(response.tabs_urls);
      pushUrl(response.url);

      if (options.successCallbackOnce) {
        options.successCallbackOnce();
      }
    },
  };
}

const restartPulling = (url, options) => {
  stopPulling();
  startPulling(url, options);
};

const reloadWithFilters = (options) => {
  restartPulling(form.data("pull-url"), getFiltersSortPullOptions(options));
};

const bindFilters = () => {
  form.on("click", "input[type=checkbox]", () => {
    const filtersUpdated = $("#filters_updated");

    const autocompleteTermsFilters = document.getElementById(
      "autocomplete_term_filters"
    );
    if (autocompleteTermsFilters) {
      autocompleteTermsFilters.value = "";
    }

    // On indique qu'on a changé les filtres pour relancer la recherche
    // car peut-être que de nouveux hôtels sont concernés par les filtres
    filtersUpdated.val(1);

    const successCallbackOnce = () => {
      filtersUpdated.val("");
    };

    reloadWithFilters({
      scrollToTop: true,
      successCallbackOnce,
      beforeSendCallbackOnce() {
        rebuildContent();
      },
    });

    if (HAP.map_data) {
      setFeedback("updating_map");
    }
  });
};

const bindSort = () => {
  $("#sorting").on("change", (e) => {
    $("#filter_sort").val(e.target.value);

    restartPulling(
      form.data("pull-url"),
      getFiltersSortPullOptions({
        beforeSendCallbackOnce() {
          rebuildContent();
        },
      })
    );
  });
};

const bindTopForm = () => {
  $("#top-form-inputs").on("submit", (e) => {
    if ($("#autocompleted").val() !== "1") {
      e.preventDefault();

      const formatDate = (date) => {
        return date
          ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
          : "";
      };

      const checkinDate = $("#arrival").datepicker("getDate");
      const checkoutDate = $("#leaving").datepicker("getDate");

      $("#filter_checkin_date").val(formatDate(checkinDate));
      $("#filter_checkout_date").val(formatDate(checkoutDate));

      const datesUpdated = $("#dates_updated");
      if (datesUpdated.length) datesUpdated.val(1);

      const successCallbackOnce = () => {
        if (checkinDate && checkoutDate) {
          $("#top-form-inputs").removeClass("active");
          $("#top-form-results").addClass("active");
        } else {
          $("#top-form-inputs").addClass("active");
          $("#top-form-results").removeClass("active");
        }

        if (datesUpdated.length) {
          datesUpdated.val("");
        }
      };

      reloadWithFilters({
        scrollToTop: false,
        successCallbackOnce,
        beforeSendCallbackOnce() {
          rebuildContent();
        },
      });
    }
  });
};

const initializeFeedback = () => {
  const element = React.createElement(SearchResultsFeedback);
  feedback = ReactDOM.render(
    element,
    document.getElementById("search-feedback")
  );
};

function initialize() {
  form = $("#filters-to-show");
  lastSuccessResultsCount = 0;

  initializeFeedback();

  if (HAP.search_list) {
    searchTemplate = "list";

    startPulling(HAP.search_list.pull_url);

    bindFilters();
    bindSort();
  } else if (HAP.search_photos) {
    searchTemplate = "photos";
    startPulling(HAP.search_photos.pull_url);

    bindFilters();
    bindSort();
  } else if (HAP.map_data) {
    searchTemplate = "map";
    bindFilters();
  }

  bindTopForm();
}

document.addEventListener("js-ready", () => {
  const onSearch =
    document.getElementById("search-content") ||
    document.getElementById("search-map");

  if (onSearch) {
    initialize();
  }
});
